import { ShortTaxMessage } from '@vp/swan';
import { __ } from '@99designs/i18n';

const MARKETS_WITHOUT_VAT_MESSAGE = ['in', 'au', 'sg', 'nz', 'us', 'ca'];

interface VATMessageProps {
    market?: string;
    vatInclusive?: boolean;
}

export function VATMessage({ market, vatInclusive }: VATMessageProps): React.ReactNode | null {
    if (MARKETS_WITHOUT_VAT_MESSAGE.includes(market?.toLowerCase() || '')) return null;

    const vatInc = __('inc. VAT', {
        _context:
            'Short tax message displayed next to the VAT-inclusive price of a design service product.',
    });
    const vatEx = __('ex. VAT', {
        _context:
            'Short tax message displayed next to the VAT-exclusive price of a design service product.',
    });

    return vatInclusive ? (
        <ShortTaxMessage>{` (${vatInc})`}</ShortTaxMessage>
    ) : (
        <ShortTaxMessage>{` (${vatEx})`}</ShortTaxMessage>
    );
}
